import React from "react";

const roleLabels = {
    user: "Пользователь",
    admin: "Администратор",
    partner: "Партнёр",
    superAdmin: "Супер-администратор",
    storeOwner: "Владелец офиса",
    officeWorker: "Сотрудник офиса",
    cityAdmin: "Городской администратор",
};

const getValue = (value) => (
    value === null || value === undefined || value === "" ? "—" : value
);

const getRegion = (user) => (
    user?.regionName || user?.region?.name || user?.region?.label || "—"
);

const getGender = (value) => (
    value === "male" ? "Мужской" : value === "female" ? "Женский" : getValue(value)
);

const formatDate = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "—";

    return date.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const DetailItem = ({ label, value, full = false }) => (
    <div className={`userDetailsProfile__item${full ? " is-full" : ""}`}>
        <span>{label}</span>
        <b>{getValue(value)}</b>
    </div>
);

const DetailsContent = ({ userDetails = {}, isSuperAdmin, onNavigate }) => {
    const emailVerified = !!(userDetails.isActivated || userDetails.emailVerifiedAt);
    const active = userDetails.isActive !== false;
    const canManage = isSuperAdmin && userDetails.role !== "superAdmin";
    const fullName = [userDetails.firstName, userDetails.lastName]
        .filter(Boolean)
        .join(" ")
        .trim() || "Без имени";

    return (
        <div className="userDetailsProfile">
            <div className="userDetailsProfile__hero">
                <div>
                    <span className="userDetailsProfile__eyebrow">Пользователь</span>
                    <h3>{fullName}</h3>
                    <p>{userDetails.email || "Email не указан"}</p>
                </div>

                <div className="userDetailsProfile__statuses">
                    <span className={active ? "is-success" : "is-danger"}>
                        {active ? "Активен" : "Отключён"}
                    </span>
                    <span className={emailVerified ? "is-success" : "is-warning"}>
                        {emailVerified ? "Email подтверждён" : "Email не подтверждён"}
                    </span>
                    <span>{roleLabels[userDetails.role] || userDetails.role || "—"}</span>
                </div>
            </div>

            {!userDetails.region && !userDetails.regionName ? (
                <div className="userDetailsProfile__warning">
                    У профиля не указан регион. Это старый профиль; superAdmin может заполнить регион через редактор профиля.
                </div>
            ) : null}

            {!emailVerified && canManage ? (
                <div className="userDetailsProfile__securityWarning">
                    <div>
                        <b>Email пользователя не подтверждён</b>
                        <span>Можно повторно отправить код и подтвердить адрес в разделе безопасности.</span>
                    </div>
                    <button type="button" onClick={() => onNavigate?.("security")}>
                        Перейти к подтверждению
                    </button>
                </div>
            ) : null}

            <div className="userDetailsProfile__sections">
                <section>
                    <h4>Основные данные</h4>
                    <div className="userDetailsProfile__grid">
                        <DetailItem label="Имя" value={userDetails.firstName} />
                        <DetailItem label="Фамилия" value={userDetails.lastName} />
                        <DetailItem label="Дата рождения" value={userDetails.birthData} />
                        <DetailItem label="Пол" value={getGender(userDetails.gender)} />
                        <DetailItem label="Регион" value={getRegion(userDetails)} />
                        <DetailItem label="Организация" value={userDetails.nameOrganization} />
                    </div>
                </section>

                <section>
                    <h4>Контакты</h4>
                    <div className="userDetailsProfile__grid">
                        <DetailItem label="Email" value={userDetails.email} full />
                        <DetailItem label="Основной телефон" value={userDetails.contactNumber} />
                        <DetailItem label="Резервный телефон" value={userDetails.backupNumber} />
                    </div>
                </section>

                <section>
                    <h4>Система</h4>
                    <div className="userDetailsProfile__grid">
                        <DetailItem label="Роль" value={roleLabels[userDetails.role] || userDetails.role} />
                        <DetailItem label="Статус" value={active ? "Активен" : "Отключён"} />
                        <DetailItem label="Email" value={emailVerified ? "Подтверждён" : "Не подтверждён"} />
                        <DetailItem label="Регистрация" value={formatDate(userDetails.createdAt)} />
                        <DetailItem label="Обновление" value={formatDate(userDetails.updatedAt)} />
                        <DetailItem label="ID" value={userDetails._id} full />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default DetailsContent;
